import { useCallback, useEffect, useState } from "react";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Button } from "./ui/button";

export const UntopicedEvidenceCard = () => {
  const [groups, setGroups] = useState(null);
  const [topics, setTopics] = useState([]);
  const [pick, setPick] = useState({});
  const [busy, setBusy] = useState("");

  const load = useCallback(async () => {
    try {
      const [{ data: g }, { data: t }] = await Promise.all([
        api.get("/training-evidence/untopiced"),
        api.get("/training/topics"),
      ]);
      setGroups(g.groups || []);
      setTopics(Array.isArray(t) ? t : (t.topics || []));
    } catch { setGroups([]); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const assign = async (slug) => {
    const tid = pick[slug];
    if (!tid) { toast.error("Pick a topic first"); return; }
    setBusy(slug);
    try {
      const { data } = await api.post("/training-evidence/assign-topic-bulk", { topic_id: tid, slugs: [slug] });
      toast.success(`Assigned topic to ${data.updated} record(s)`);
      load();
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setBusy(""); }
  };

  if (!groups || !groups.length) return null;
  const total = groups.reduce((a, g) => a + g.count, 0);
  return (
    <div className="mt-8 rounded-lg border border-[#B7791F]/30 bg-white p-5 shadow-sm" data-testid="untopiced-evidence-card">
      <p className="text-sm font-semibold text-stone-800">Evidence files without a topic ({total})</p>
      <p className="mt-0.5 text-xs text-stone-400">These attached to staff but the filename didn&rsquo;t map to a training topic. Pick the right topic per group — one click fixes them all.</p>
      <div className="mt-3 space-y-1.5">
        {groups.map((g) => (
          <div key={g.slug} className="flex flex-wrap items-center gap-2 rounded-md border border-stone-200 px-2.5 py-1.5 text-xs" data-testid={`untopiced-${g.slug.slice(0, 24)}`}>
            <span className="min-w-40 flex-1 truncate font-medium text-stone-700" title={g.example}>
              {g.slug} <span className="text-stone-400">({g.count} file{g.count === 1 ? "" : "s"})</span>
            </span>
            <select value={pick[g.slug] || ""} onChange={(e) => setPick((p) => ({ ...p, [g.slug]: e.target.value }))}
              className="h-7 max-w-56 rounded-md border border-stone-300 px-1 text-[11px]" data-testid={`untopiced-select-${g.slug.slice(0, 16)}`}>
              <option value="">Choose topic…</option>
              {topics.map((t) => <option key={t.id} value={t.id}>{t.title}</option>)}
            </select>
            <Button size="sm" onClick={() => assign(g.slug)} disabled={busy === g.slug} className="bg-primary text-primary-foreground" data-testid={`untopiced-assign-${g.slug.slice(0, 16)}`}>
              {busy === g.slug ? "Assigning…" : "Assign all"}
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};
